<template>
  <div class="gray-bcg">
    <img
      src="../assets/image/blueShape.png"
      alt="blueShape"
      class="blueShape"
      width="70%"
    />
    <img
      src="../assets/image/greenShape.png"
      alt="greenShape"
      width="50%"
      class="greenShape"
    />

    <myheader class="z3" />
    <order class="z3" />
    <prices class="z3 mt-n16" />
    <benefits class="z3 mb-10" />
    <carousel class="z3 d-none" />
    <myfooter class="z3" />
  </div>
</template>

<script>
import myheader from "../components/Share/Header.vue";
import order from "../components/Home/Order.vue";
import prices from "../components/Home/Prices.vue";
import benefits from "../components/Home/Benefits.vue";
import carousel from "../components/Home/Carousel.vue";
import myfooter from "../components/Share/Footer";

export default {
  name: "Home",

  components: {
    myheader,
    order,
    prices,
    benefits,
    carousel,
    myfooter,
  },
};
</script>
<style scoped>
.greenShape {
  position: absolute;
  top: 20%;
  right: 75%;
}
.blueShape {
  position: absolute;
  top: 15%;
  right: -40%;
}
</style>
